import { Pipe, PipeTransform } from '@angular/core';
import { RecurrenceRepeat } from '@core/interfaces';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';


@Pipe({
  name: 'recurrenceDescriptionHumanizer'
})
export class RecurrenceDescriptionHumanizerPipe implements PipeTransform {

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  transform(recurrenceRepeat: RecurrenceRepeat): string {
    const from = recurrenceRepeat.from
      ? moment(recurrenceRepeat.from).format('DD/MM/YYYY')
      : '00/00/0000';

    const until = recurrenceRepeat.until
      ? this.translateService.instant('RECURRENCE.END_DATE_AT', { until: moment(recurrenceRepeat.until).format('DD/MM/YYYY') })
      : this.translateService.instant('RECURRENCE.WITHOUT_END_DATE');

    const every = recurrenceRepeat.every || 0;

    const interval = this.intervalDescription(recurrenceRepeat);

    const skipWeekend = recurrenceRepeat.skipWeekend && recurrenceRepeat.interval !== 'weekly'
      ? this.translateService.instant('RECURRENCE.DESCRIPTION_SKIP_WEEKEND')
      : '';

    const interpolateParams = {
      from,
      until,
      every,
      interval,
      skipWeekend
    };

    return this.translateService.instant('RECURRENCE.EXPLANATION', interpolateParams)
      .replaceAll(/\s\s+/g, ' ')
      .replaceAll(/\s\./g, '.');
  }

  intervalDescription(recurrenceRepeat: RecurrenceRepeat): string {
    switch (recurrenceRepeat.interval) {
      case 'monthly':
        const dayOfMonth = recurrenceRepeat.dayOfMonth || 0;
        return this.translateService.instant('RECURRENCE.DESCRIPTION_MONTHS', {
          dayOfMonth
        });

      case 'weekly':
        const weekdayUpperCased = (recurrenceRepeat.weekday || 'monday').toUpperCase();
        const weekday = this.translateService.instant(`RECURRENCE.WEEKDAY.${weekdayUpperCased}`);
        return this.translateService.instant('RECURRENCE.DESCRIPTION_WEEKS', {
          weekday
        });

      case 'daily':
      default:
        return this.translateService.instant('RECURRENCE.DESCRIPTION_DAYS');
    }
  }
}
